// extracted by mini-css-extract-plugin
export var formContainer = "_g9-0";
export var message = "_g9-1";